import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { LinkValidationResponse } from '../../../shared/entities/LinkValidationResponse';
import { UserCredentials } from '../../../shared/entities/UserCredentials';
import { UserCredentialsFromApnLink } from '../../../shared/entities/UserCredentialsFromApnLink';

const VALIDATE_USER_NAME_LANAI = 'User/ValidateUserName';
const USER_IS_ADMIN = 'User/IsUserAdmin';
const VALIDATE_APN_AUTH_LINK = 'Credential/ValidateApnLink';
const GET_USER_DETAILS_BY_USER_ID = 'Credential/GetUserDetailsByUserId';
const GET_SPACE_SESSION_ID = 'Credential/getinitdata';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class AuthService {
  subValidationLink: Subscription;
  defaultLotId: string = '';
  activeLotName: string = '';
  isUserAdmin: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  public setRoleIsAdmin(isAdmin: boolean): void {
    this.isUserAdmin = isAdmin;
  }

  public isThisUserRoleAdmin(): boolean {
    return this.isUserAdmin;
  }

  public setLotName(lotName: string): void {
    this.activeLotName = lotName;
  }

  public getLotName(): string {
    return this.activeLotName;
  }

  // public setAuthenticated(authValue: boolean): void {
  //   this.userIsAuthenticated = authValue;
  // }

  // public isAuthenticated(): boolean {
  //   return this.userIsAuthenticated;
  // }

  public setDefaultLotId(lotId: string): void {
    this.defaultLotId = lotId;
  }

  public getDefaultLotId(): string {
    return this.defaultLotId;
  }

  // public setUserName(userName: string): void {
  //   this.currentUser.next(userName);
  //   this.userName = userName;
  // }

  // public getUserName(): string {
  //   return this.userName;
  // }

  // public setUserId(userId: string): void {
  //   this.userId = userId;
  // }

  // public getUserId(): string {
  //   return this.userId;
  // }

  // onCurrentUserUpdated(): Observable<string> {
  //   return this.currentUser.asObservable();
  // }

  userIdAdminRole(userName: string): Observable<boolean> {
    let queryString: string = `userName=${userName}`;

    if (environment.production == false) var endpoint = environment.RestServer + USER_IS_ADMIN + `?${queryString}`;
    else var endpoint = environment.RestServer + USER_IS_ADMIN + `?${queryString}`;

    return this.http.get<boolean>(endpoint);
  }

  validateUserName(userName: string): Observable<UserCredentials> {
    let queryString: string = `userName=${userName}`;

    if (environment.production == false)
      var endpoint = environment.RestServer + VALIDATE_USER_NAME_LANAI + `?${queryString}`;
    else var endpoint = environment.RestServer + VALIDATE_USER_NAME_LANAI + `?${queryString}`;

    return this.http.get<UserCredentials>(endpoint);
  }

  validateApnLink(linkId: string): Observable<LinkValidationResponse> {
    let queryString: string = `validationLink=${linkId}`;

    if (environment.production == false)
      var endpoint = environment.RestServer + VALIDATE_APN_AUTH_LINK + `?${queryString}`;
    else var endpoint = environment.RestServer + VALIDATE_APN_AUTH_LINK + `?${queryString}`;

    return this.http.get<LinkValidationResponse>(endpoint);
  }

  getApnUserDataByUserId(userId: string): Observable<HttpResponse<UserCredentialsFromApnLink>> {
    let queryString: string = `userId=${userId}`;

    if (environment.production == false)
      var endpoint = environment.RestServer + GET_USER_DETAILS_BY_USER_ID + `?${queryString}`;
    else var endpoint = environment.RestServer + GET_USER_DETAILS_BY_USER_ID + `?${queryString}`;

    return this.http.get<UserCredentialsFromApnLink>(endpoint, { observe: 'response' });
  }

  getspaceDetails(): Observable<HttpResponse<any>> {
    if (environment.production == false) var endpoint = environment.RestServer + GET_SPACE_SESSION_ID;
    else var endpoint = environment.RestServer + GET_SPACE_SESSION_ID;

    return this.http.get<UserCredentialsFromApnLink>(endpoint, { observe: 'response' });
  }
}
